import { FC, Fragment } from 'react'
import { LargeProductSuitCardsData } from '../types'
import { Stack, theme } from '@dtx-company/design-system/src'
import { asText } from '@prismicio/client'
import LargeProductSuitCard from './LargeProductSuitCard'
import PrismicText from '@app/prismic/src/components/PrismicText/PrismicText'

//sectionId is used for navigation
const LargeProductSuitCardsSection: FC<{
  data?: LargeProductSuitCardsData
  sectionId: string
}> = ({ data, sectionId }) => {
  if (!data) return null

  return (
    <Stack
      id={sectionId}
      spacing={{
        xs: theme.spacing(14)
      }}
      direction="column"
      justifyContent="center"
      sx={{
        my: {
          _: theme.spacing(8),
          md: theme.spacing(14),
          lg: theme.spacing(24)
        }
      }}
    >
      {data?.items?.map((item, index) => (
        <Fragment key={asText(item.subheader)}>
          {index === 1 && (
            <PrismicText
              key={asText(data.primary?.subheader)}
              richTextField={data.primary?.subheader}
              variant="display/large"
              fontSize={{ _: '24px', md: '28px', lg: '32px' }}
              lineHeight={{ _: '30px', lg: '40px' }}
              textAlign="center"
              marginBottom="56px"
              px={{ _: '22px', md: '133px' }}
            />
          )}
          <LargeProductSuitCard data={item} />
        </Fragment>
      ))}
    </Stack>
  )
}

export default LargeProductSuitCardsSection
